import { ApiService }              from '../../app-lite/api/api.service';
import { CompanyMessagesModel }    from '../../app-lite/companies/models/company.messages';
import { SessionService }          from '../../app-lite/sessions/session.service';
import { TemplatedWordingService } from '../../app-lite/templates/templated-wording.service';
import { TemplateModel }           from '../../app-lite/templates/typings/template';
import { WorkshopPayService }      from '../../app-lite/workshoppay/workshoppay.service';

interface CompanyMessagesScope extends ng.IScope {
  addSMSTemplates   : ( type : string ) => void;
  addTemplates      : ( type : string ) => void;
  block             : ng.blockUI.BlockUIService;
  companyMessages   : CompanyMessagesModel;
  getDefaultMessages: () => void;
  save              : ( form : ng.IFormController ) => void;
  session           : any;
  toolbar           : Array<Array<string>>;
  workshopPayApi    : WorkshopPayService;
};

export function CompanyMessagesCtrl (
  $scope          : CompanyMessagesScope,
  $state          : ng.ui.IStateService,
  $translate      : ng.translate.ITranslateService,
  blockUI         : ng.blockUI.BlockUIService,
  companyMessages : CompanyMessagesModel,
  messages        : any,
  sessionObjAPI   : SessionService,
  templatedWording: TemplatedWordingService,
  workshopAPI     : ApiService,
  workshopPayApi  : WorkshopPayService
) {

  $scope.block           = blockUI.instances.get('companyMessagesBlock');
  $scope.companyMessages = companyMessages;
  $scope.session         = sessionObjAPI.base();
  $scope.workshopPayApi  = workshopPayApi;

  $scope.addSMSTemplates = function ( type : string ) {
    templatedWording.addTemplate('sms')
    .then(( templates : Array<TemplateModel> ) => {
      angular.forEach(templates, template => {
        switch (type) {
          case 'invoice':
            $scope.companyMessages.default_invoice_sms_message = $scope.companyMessages.default_invoice_sms_message ?
            `${ $scope.companyMessages.default_invoice_sms_message }
            ${ template.wording }` :
            template.wording;
            break;
          case 'inspection':
            $scope.companyMessages.inspection_sms_message = $scope.companyMessages.inspection_sms_message ?
            `${ $scope.companyMessages.inspection_sms_message }
            ${ template.wording }` :
            template.wording;
            break;
        }

      });
    });
  };

  $scope.addTemplates = function ( type : string ) {
    templatedWording.addTemplate('email')
    .then(templates => {
      angular.forEach(templates, template => {
        switch (type) {
          case 'invoice':
            $scope.companyMessages.invoice_email_message = $scope.companyMessages.invoice_email_message ?
            `${ $scope.companyMessages.invoice_email_message }
            ${ template.wording }` :
            template.wording;
            break;
          case 'statement':
            $scope.companyMessages.statement_email_message = $scope.companyMessages.statement_email_message ?
            `${ $scope.companyMessages.statement_email_message }
            ${ template.wording }` :
            template.wording;
            break;
          case 'supplier':
            $scope.companyMessages.supplier_email_message = $scope.companyMessages.supplier_email_message ?
            `${ $scope.companyMessages.supplier_email_message }
            ${ template.wording }` :
            template.wording;
            break;
          case 'inspection':
            $scope.companyMessages.inspection_email_message = $scope.companyMessages.inspection_email_message ?
            `${ $scope.companyMessages.inspection_email_message }
            ${ template.wording }` :
            template.wording;
            break;
          case 'vendor_invoice':
            $scope.companyMessages.vendor_invoice_email_message = $scope.companyMessages.vendor_invoice_email_message ?
            `${ $scope.companyMessages.vendor_invoice_email_message }
            ${ template.wording }` :
            template.wording;
            break;
          default:
            $scope.companyMessages.customer_email_message = $scope.companyMessages.customer_email_message ?
            `${ $scope.companyMessages.customer_email_message }
            ${ template.wording }` :
            template.wording;
            break;
        }
      });
    });
  };

  $scope.getDefaultMessages = function () {
    angular.forEach($scope.companyMessages, ( value, key ) => {
      if ( value === null ) {
        $scope.companyMessages[key] = '';
      }
    });

    if ( $scope.companyMessages.invoice_email_message === null ) {
      $scope.companyMessages.invoice_email_message = '';
    }

    if ( $scope.companyMessages.statement_email_message === null ) {
      $scope.companyMessages.statement_email_message = '';
    }

    if ( $scope.companyMessages.supplier_email_message === null ) {
      $scope.companyMessages.supplier_email_message = '';
    }

    if ( $scope.companyMessages.customer_email_message === null ) {
      $scope.companyMessages.customer_email_message = '';
    }

    if ( $scope.companyMessages.inspection_email_message === null ) {
      $scope.companyMessages.inspection_email_message = '';
    }

    if ( $scope.companyMessages.loan_terms_and_conditions_message === null ) {
      $scope.companyMessages.loan_terms_and_conditions_message = '';
    }
  };

	$scope.save = function ( form : ng.IFormController ) {
    $scope.block.start();

    workshopAPI.patch('/company_message_settings', $scope.companyMessages)
    .then(() => {
      form.$setPristine();

      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.FOOTERS_MESSAGES'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
	};

  $scope.getDefaultMessages();
};